import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Home as HomeIcon, User, MapPin, Compass, Bell } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { API } from '../config/constants';

const BottomNav = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const { pathname: location } = typeof window !== 'undefined' ? window.location : { pathname: '/' };
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!token) {
      setUnreadCount(0);
      return undefined;
    }

    let isActive = true;
    const fetchUnreadCount = async () => {
      try {
        const response = await axios.get(`${API}/notifications/unread-count`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (isActive) setUnreadCount(response.data.count || 0);
      } catch (error) {
        if (isActive) setUnreadCount(0);
      }
    };

    fetchUnreadCount();
    const interval = window.setInterval(fetchUnreadCount, 60000);
    return () => {
      isActive = false;
      window.clearInterval(interval);
    };
  }, [token]);

  return (
    <div className="fixed bottom-0 left-0 right-0 h-20 bg-[#0B0B0C]/90 backdrop-blur-xl border-t border-white/5 flex justify-around items-center z-40 pb-2">
      <button
        data-testid="nav-home-button"
        onClick={() => navigate('/')}
        className={`flex flex-col items-center gap-1 transition-colors ${
          location === '/' ? 'text-amber-500' : 'text-white/40 hover:text-white/70'
        }`}
      >
        <HomeIcon size={24} />
        <span className="text-xs">Home</span>
      </button>
      <button
        data-testid="nav-lounges-button"
        onClick={() => navigate('/lounges')}
        className={`flex flex-col items-center gap-1 transition-colors ${
          location === '/lounges' || location.startsWith('/lounge/') ? 'text-amber-500' : 'text-white/40 hover:text-white/70'
        }`}
      >
        <MapPin size={24} />
        <span className="text-xs">Lounges</span>
      </button>
      <button
        data-testid="nav-discover-button"
        onClick={() => {
          if (!token) {
            navigate('/auth?reason=discover');
          } else {
            navigate('/discover');
          }
        }}
        className={`flex flex-col items-center gap-1 transition-colors ${
          location === '/discover' ? 'text-amber-500' : 'text-white/40 hover:text-white/70'
        }`}
      >
        <Compass size={24} />
        <span className="text-xs">Discover</span>
      </button>
      <button
        data-testid="nav-notifications-button"
        onClick={() => {
          if (!token) {
            navigate('/auth?reason=notifications');
          } else {
            navigate('/notifications');
          }
        }}
        className={`flex flex-col items-center gap-1 transition-colors ${
          location === '/notifications' ? 'text-amber-500' : 'text-white/40 hover:text-white/70'
        }`}
      >
        <span className="relative">
          <Bell size={24} />
          {unreadCount > 0 && (
            <span data-testid="nav-notifications-badge" className="absolute -top-2 -right-3 min-w-4 h-4 px-1 rounded-full bg-red-500 text-white text-[10px] leading-4 text-center font-bold">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </span>
        <span className="text-xs">Notifications</span>
      </button>
      <button
        data-testid="nav-profile-button"
        onClick={() => {
          if (!token) {
            navigate('/auth?reason=profile');
          } else {
            navigate('/profile');
          }
        }}
        className={`flex flex-col items-center gap-1 transition-colors ${
          location === '/profile' ? 'text-amber-500' : 'text-white/40 hover:text-white/70'
        }`}
      >
        <User size={24} />
        <span className="text-xs">Profile</span>
      </button>
    </div>
  );
};

export default BottomNav;
